import { render } from "./Privacy.vue?vue&type=template&id=08f5f782&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=08f5f782&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f5f782"]])

export default __exports__